import ReactDOM from 'react-dom';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from '../common/graphql/localState/client';
import { HeaderSharedComponent } from './component/HeaderSharedComponent';
import { ToastContainerSharedComponent } from './component/ToastContainerSharedComponent';
import { Campaign } from '../generated/contentful-generated-types';
import { PromoBanner } from '../components/PromoBanner';
import { FooterSharedComponent } from './component/FooterSharedComponent';
import { SiretInputShared } from './component/SiretInputShared';
import { GetFullCompanyInformation_fullCompanyInformation } from '../common/graphql';
import { LoginFormSharedComponent } from './component/LoginFormSharedComponent';
import { LoginFormContextProvider } from '../login/LoginFormContext';
import { ChatWidgetSharedComponent } from './component/ChatWidgetSharedComponent';

/*
This file is the entry point for webpack to generate the shared-component bundle
*/
export const renderHeader = (rootElementId: string, hideNavigation: boolean, isFunnel = false) => {
  const apolloClient = getApolloClient();
  // Add resetApolloStore on every shared pages (with shared component)
  (global as any).resetApolloStore = async () => {
    await apolloClient.resetStore();
  };

  ReactDOM.render(
    <ApolloProvider client={apolloClient}>
      <ToastContainerSharedComponent />
      <LoginFormContextProvider>
        <HeaderSharedComponent hideNavigation={hideNavigation} isFunnel={isFunnel} />
      </LoginFormContextProvider>
    </ApolloProvider>,
    document.getElementById(rootElementId)
  );
};

export const renderFooter = (rootElementId: string, hideNavigation: boolean, pageType: string) => {
  ReactDOM.render(
    <ApolloProvider client={getApolloClient()}>
      <FooterSharedComponent hideNavigation={hideNavigation} pageType={pageType} />
    </ApolloProvider>,
    document.getElementById(rootElementId)
  );
};

export const renderPromoBanner = (rootElementID: string, campaign: Campaign[] | Campaign) => {
  //For transition time when AMS still pass a single campaign for the second parameter of this function
  const campaigns = campaign instanceof Array ? campaign : [campaign];

  ReactDOM.render(
    <ApolloProvider client={getApolloClient()}>
      <PromoBanner campaigns={campaigns} />
    </ApolloProvider>,
    document.getElementById(rootElementID)
  );
};

export const renderLoginForm = (rootElementID: string, callback: any, saveRegister: boolean, title: string) => {
  ReactDOM.render(
    <ApolloProvider client={getApolloClient()}>
      <LoginFormSharedComponent callback={callback} saveRegister={saveRegister} title={title} />
    </ApolloProvider>,
    document.getElementById(rootElementID)
  );
};

export const renderSiretInput = (
  rootElementID: string,
  label: string,
  inputType: string,
  callback: (line: GetFullCompanyInformation_fullCompanyInformation | null) => void
) => {
  ReactDOM.render(
    <ApolloProvider client={getApolloClient()}>
      <SiretInputShared label={label} inputType={inputType} updateFieldsCallback={callback} />
    </ApolloProvider>,
    document.getElementById(rootElementID)
  );
};

export const renderChatWidget = (rootElementId: string) => {
  ReactDOM.render(
    <ApolloProvider client={getApolloClient()}>
      <ChatWidgetSharedComponent />
    </ApolloProvider>,
    document.getElementById(rootElementId)
  );
};

const getApolloClient = () => {
  return createApolloClient(process.env.GATSBY_MIDDLEWARE_URL || '', process.env.GATSBY_LOCALE || '', false);
};
